<script setup lang="ts">
import {gsap} from 'gsap';

// useMenuState().value = 'expanded';

const {cmsReady} = storeToRefs(useCmsStore());

const scrollContainer = ref<HTMLElement | null>(null);
//const scrollSections = ['homeBanner', 'icandyFeature', 'timesTravelVipFeature', 'timesTravelFeature', 'everFeature', 'articleSection', 'planSection'];

onMounted(async () => {
  gsap.matchMedia().add('(min-width: 1025px)', () => {
    window.scrollTo(0, 0);
    window.addEventListener('resize', debounce(handleResize));
  });

  // scrollContainer.value = document.querySelector('.home-container') as HTMLElement;

  // if (scrollContainer.value) {
  //   scrollContainer.value.scrollTo({
  //     top: 0,
  //     left: 0,
  //     behavior: 'smooth',
  //   });
  // }
});

interface DebouncedFunction {
  (event: Event): void;
}

function debounce(func: (event: Event) => void): DebouncedFunction {
  let timer: ReturnType<typeof setTimeout>;
  return function (event: Event) {
    if (timer) clearTimeout(timer);
    timer = setTimeout(func, 100, event);
  };
}

function handleResize() {
  location.reload();
}

onBeforeUnmount(() => {
  window.removeEventListener('resize', handleResize);
});
</script>

<template>
  <div ref="scrollContainer" class="home-container !mt-0 !gap-0">
    <section id="homeBanner" class="snap-section" data-hash="homeBanner">
      <HeroFeature />
    </section>

    <VideoScrollScrubber />

    <HomeFeatures />

    <section id="articleSection" class="snap-section" data-hash="articleSection">
      <ArticlesFeatures v-if="cmsReady" />
    </section>

    <section id="planSection" class="bg-white snap-section" data-hash="planSection">
      <PlanVisit />
    </section>

    <!-- <ScrollDownButton v-if="scrollContainer" :scroll-container="scrollContainer" :scroll-sections="scrollSections" /> -->
  </div>
</template>

<style lang="scss">
@use '@/assets/scss/queries';
.home-container {
  .snap-section {
    scroll-margin-top: var(--header-desktop-collapse-height);

    @include queries.for-size(phone) {
      scroll-margin-top: var(--header-mobile-collapse-height);
    }
  }
}
</style>
